import { gql } from 'graphql-tag'

const ShiftTypeEnum = {
  Morning: 'Morning',
  Evening: 'Evening',
  Night: 'Night',
}

const thumbableServiceFragment = gql`
  fragment ThumbableServiceFragment on ThumbsUpItem {
    id
    name
    isEnabled
  }
`

const thumbsUpTargetFragment = gql`
  fragment ThumbsUpTargetFragment on ThumbsUpTarget {
    thumbsUpTarget
    shiftPercentages {
      ${ShiftTypeEnum.Morning}
      ${ShiftTypeEnum.Evening}
      ${ShiftTypeEnum.Night}
    }
  }
`

export const fetchThumbableServices = gql`
  query FetchThumbableServices {
    thumbsUpItems {
      ...ThumbableServiceFragment
    }
  }
  ${thumbableServiceFragment}
`

export const fetchStationThumbableServices = gql`
  query FetchStationThumbableServices($stationId: ID!) {
    stationThumbsUpItems(stationId: $stationId) {
      ...ThumbableServiceFragment
    }
  }
  ${thumbableServiceFragment}
`

export const fetchStationThumbsUpTarget = gql`
  query FetchStationThumbsUpTarget($stationId: ID!, $date: String!) {
    thumbsUpTarget(stationId: $stationId, date: $date) {
      ...ThumbsUpTargetFragment
    }
  }
  ${thumbsUpTargetFragment}
`

export const upsertThumbsUpTargetMutation = gql`
  mutation UpsertThumbsUpTargetMutation($stationId: ID!, $data: CreateThumbsUpTargetInput!) {
    upsertThumbsUpTarget(stationId: $stationId, data: $data) {
      ...ThumbsUpTargetFragment
    }
  }
  ${thumbsUpTargetFragment}
`

export const createThumbableService = gql`
  mutation CreateThumbableService($name: String!, $stationId: ID) {
    createThumbsUpItem(name: $name, stationId: $stationId) {
      ...ThumbableServiceFragment
    }
  }
  ${thumbableServiceFragment}
`

export const updateThumbableService = gql`
  mutation UpdateThumbableService($id: ID!, $name: String!, $isEnabled: Boolean) {
    updateThumbsUpItem(thumbsUpItemId: $id, name: $name, isEnabled: $isEnabled) {
      ...ThumbableServiceFragment
    }
  }
  ${thumbableServiceFragment}
`

export const deleteThumbableService = gql`
  mutation DeleteThumbableService($id: ID!) {
    deleteThumbsUpItem(thumbsUpItemId: $id)
  }
`
